import { excludePresetsFromLinkCreatorData } from '../../../common/utils/linkhub-data-filter-helper';
import { Redirect as RedirectType } from '../../screens/ScreenLinkHubAdLinkCreator/steps/RedirectsStep/Redirects.types';
import { Redirect as RedirectEnum } from '../../screens/ScreenLinkHubAdLinkCreator/steps/RedirectsStep/Redirects.enums';
import { IAdLinkLinkData } from '../../../../../shared/types/links/Interfaces/IAdLinkLinkData';
import {
  IAdLink,
  AdLinkFormat,
  IAdLinkAnalyticsTags,
  IBaseRedirects,
  RedirectsClientOverride,
} from '../../../../../shared/types';

export class AdLinkEditorService {
  private static getTitle = (adLink: Record<string, any>): string => {
    return adLink?.data?.$link_title;
  };

  private static getAlias = (adLink: Record<string, any>): string => {
    return adLink?.alias;
  };

  private static getPartner = (adLink: Record<string, any>): string => {
    return adLink?.data?.$3p;
  };

  private static getFormat = (adLink: Record<string, any>): AdLinkFormat => {
    return adLink?.data?.['~branch_ad_format'];
  };

  private static getTemplateId = (adLink: Record<string, any>): AdLinkFormat => {
    return adLink?.data?.['~link_template_id'];
  };

  private static getLinkData = (adLink: Record<string, any>): IAdLinkLinkData & Record<string, string> => {
    const linkDataWithoutPresets: Record<string, any> = excludePresetsFromLinkCreatorData(adLink?.data);

    return linkDataWithoutPresets;
  };

  private static getAnalyticsTags = (adLink: Record<string, any>): IAdLinkAnalyticsTags => {
    const analyticsTags = new Object() as IAdLinkAnalyticsTags;

    if (adLink?.data?.['~channel']) {
      analyticsTags.channel = adLink?.data?.['~channel'];
    }

    if (adLink?.data?.['~campaign']) {
      analyticsTags.campaign = adLink?.data?.['~campaign'];
    }

    if (adLink?.data?.['~tags']) {
      analyticsTags.tags = adLink?.data?.['~tags'];
    }

    return analyticsTags;
  };

  private static getOsType = (adLink: Record<string, any>): string => {
    return adLink?.data?.['~os_type'];
  };

  private static getRedirectValidType = (redirect: RedirectType): RedirectsClientOverride => {
    if (redirect === RedirectEnum.Deepview) {
      return RedirectsClientOverride.Deepview;
    } else if (redirect === RedirectEnum.Web) {
      return RedirectsClientOverride.WebUrl;
    } else {
      return RedirectsClientOverride.DefaultRedirect;
    }
  };

  private static getRedirects = (adLink: Record<string, any>): IBaseRedirects => {
    const redirects: IBaseRedirects = new Object();

    if (adLink?.data?.$ios_url) {
      redirects.ios = {
        override: this.getRedirectValidType('web'),
        value: adLink?.data?.$ios_url,
      };
    }

    if (adLink?.data?.$android_url) {
      redirects.android = {
        override: this.getRedirectValidType('web'),
        value: adLink?.data?.$android_url,
      };
    }

    if (adLink?.data?.$desktop_url) {
      redirects.desktop = {
        override: this.getRedirectValidType('web'),
        value: adLink?.data?.$desktop_url,
      };
    }

    return redirects;
  };

  public static getAdLinkPayload = (adLink: Record<string, any>): IAdLink => {
    return {
      title: this.getTitle(adLink),
      alias: this.getAlias(adLink),
      partner: this.getPartner(adLink),
      format: this.getFormat(adLink),
      linkData: this.getLinkData(adLink),
      analyticsTags: this.getAnalyticsTags(adLink),
      osType: this.getOsType(adLink),
      redirects: this.getRedirects(adLink),
      templateId: this.getTemplateId(adLink),
    };
  };
}
